function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 19C0.447715 19 0 19.4477 0 20C0 21.1046 0.895431 22 2 22H26C27.1046 22 28 21.1046 28 20C28 19.4477 27.5523 19 27 19H17C17 19.5523 16.5523 20 16 20H12C11.4477 20 11 19.5523 11 19H1Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 6C3.44772 6 3 6.44772 3 7V19H25V7C25 6.44772 24.5523 6 24 6H4ZM24 7H4V18H24V7Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4749 9.99009C10.6701 9.79483 10.9867 9.79483 11.182 9.99009C11.3773 10.1854 11.3773 10.5019 11.182 10.6972L9.06067 12.8185C8.86541 13.0138 8.54883 13.0138 8.35357 12.8185C8.15831 12.6233 8.15831 12.3067 8.35357 12.1114L10.4749 9.99009Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0607 14.9398C17.8654 15.1351 17.5488 15.1351 17.3535 14.9398C17.1583 14.7446 17.1583 14.428 17.3535 14.2327L19.4749 12.1114C19.6701 11.9162 19.9867 11.9162 20.182 12.1114C20.3772 12.3067 20.3772 12.6233 20.182 12.8185L18.0607 14.9398Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.182 14.2327C11.3772 14.428 11.3772 14.7446 11.182 14.9398C10.9867 15.1351 10.6701 15.1351 10.4749 14.9398L8.35357 12.8185C8.15831 12.6233 8.15831 12.3067 8.35357 12.1114C8.54883 11.9161 8.8654 11.9162 9.06066 12.1114L11.182 14.2327Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3536 10.6972C17.1583 10.5019 17.1583 10.1854 17.3536 9.99009C17.5488 9.79483 17.8654 9.79483 18.0607 9.99009L20.182 12.1114C20.3772 12.3067 20.3772 12.6233 20.182 12.8185C19.9867 13.0138 19.6701 13.0138 19.4749 12.8185L17.3536 10.6972Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8933 9.46036C15.0011 9.20611 15.2946 9.08736 15.5488 9.19511C15.8031 9.30287 15.9218 9.59634 15.8141 9.85059L13.4727 15.3749C13.3649 15.6291 13.0715 15.7479 12.8172 15.6401C12.563 15.5324 12.4442 15.2389 12.552 14.9847L14.8933 9.46036Z",
  fill: "currentColor"
});

var SvgServices = function SvgServices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Services.69136a37.svg";
export { ForwardRef as ReactComponent };